import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";
import { PaginationContextProvider } from "@ds-cps/ui";

import {
  BreadCrumbItem,
  CustomBreadCrumb
} from "@components/BreadCrumb/CustomBreadCrumb";

import { UnAuthorizedPage } from "@account/pages/UnAuthorizedPage";
import { AuditLogContextProvider } from "@audit-log/context";

import { useUserContext } from "@hooks/useUserContext";

import { AuditLogOverview } from "../components/AuditLogOverview";

export const AuditLogPage = () => {
  // Note
  // Using setBreadcrumbs() from usePageContext() here, causes infinite rendering.
  // Need time to research or migrate to <Shell> entirely.

  const { user } = useUserContext();

  const { t: tCommon } = useTranslation();
  const { t } = useTranslation(undefined, { keyPrefix: "audit-log" });

  const breadCrumbs: BreadCrumbItem[] = [
    {
      name: tCommon("home.nav_item.label"),
      url: "/"
    },
    {
      name: tCommon("audit-log.nav_item.label")
    }
  ];

  // !!!
  // When used as <Page breadcrumbs={shellBreadcrumbs}> it causes Infinite rendering
  // !!!

  if (user.isReader) {
    return <UnAuthorizedPage />;
  }

  return (
    <Page title={t("page_title")}>
      <CustomBreadCrumb breadCrumbs={breadCrumbs} />
      <div className="flex flex-col" data-testid="audit-log-overview-content">
        <AuditLogContextProvider>
          <PaginationContextProvider>
            <AuditLogOverview />
          </PaginationContextProvider>
        </AuditLogContextProvider>
      </div>
    </Page>
  );
};
